module.exports = __webpack_public_path__ + "img/office_msk.1cee6826.png";